import { Accordion, AccordionItemBodyProps } from '@chakra-ui/react';
import React from 'react';

/*
 * v2's `AccordionPanel` was a single element carrying the panel padding. v3
 * splits it in two: `Accordion.ItemContent` is the animated open/close
 * wrapper, and `Accordion.ItemBody` carries the padding (the recipe's
 * `itemBody` slot — e.g. the `base` variant's 1.5rem sides). Rendering only
 * the wrapper silently drops that padding, so this composes both and sends
 * props to the body, keeping `<MAccordionPanel px={6}>` meaning what it did.
 */
const MAccordionPanel = React.forwardRef<
  HTMLDivElement,
  AccordionItemBodyProps
>(({ children, ...rest }, ref) => (
  <Accordion.ItemContent>
    <Accordion.ItemBody ref={ref} {...rest}>
      {children}
    </Accordion.ItemBody>
  </Accordion.ItemContent>
));

export default MAccordionPanel;
